"use client";

import React from "react";
import "./LocationSectionNew.css";
import { motion } from "framer-motion";
export default function LocationSectionNew({
  projectDetail,
  dispatch,
  setProximityToggle,
  staticProjectDetail,
}) {
  if (!projectDetail?.map_iframe) return null;

  return (
    <section className="location-new-section section-padding">
      <div className="main-container-fluid">
        <div className="location-new-grid">
          {/* LEFT */}

          <motion.div
            className="location-content inner-flex inner-flex-medium"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
            }}
          >
            <div className="section-title">
              <h2>{projectDetail?.location_title || "Location"}</h2>
            </div>

            <div className="inner-flex inner-flex-small">
              {projectDetail?.location_tag_line && (
                <div className="inner-flex section-paragraph inner-flex-smallest">
                  <p>Address</p>

                  <a
                    href={projectDetail?.map_slug}
                    target="_blank"
                    className="wfc"
                  >
                    <p
                      className="wfc"
                      dangerouslySetInnerHTML={{
                        __html: projectDetail.location_tag_line,
                      }}
                    />
                  </a>
                </div>
              )}

              <div className="location-row-grid">
                {projectDetail?.project_contact_email && (
                  <div className="inner-flex section-paragraph inner-flex-smallest">
                    <p>Email</p>

                    <a
                      href={`mailto:${projectDetail.project_contact_email}`}
                      className="wfc"
                    >
                      <p className="wfc">
                        {projectDetail.project_contact_email}
                      </p>
                    </a>
                  </div>
                )}

                {projectDetail?.project_contact_no && (
                  <div className="inner-flex section-paragraph inner-flex-smallest">
                    <p>Phone</p>

                    <a
                      className="wfc"
                      href={`tel:${projectDetail.project_contact_no}`}
                    >
                      <p className="wfc">+{projectDetail.project_contact_no}</p>
                    </a>
                  </div>
                )}
              </div>

              <div className="location-buttons">
                <a
                  href={projectDetail?.map_slug}
                  target="_blank"
                  className="wfc"
                >
                  <button
                    className="
                    reecosys-template-button
                    button-style-secondary
                    "
                  >
                    <p>View on Map</p>
                  </button>
                </a>

                {staticProjectDetail?.proximityData?.length > 0 && (
                  <button
                    className="
                    reecosys-template-button
                    button-style-primary-outline
                    "
                    onClick={() => dispatch(setProximityToggle(true))}
                  >
                    <p>View Proximities</p>
                  </button>
                )}
              </div>
            </div>
          </motion.div>

          {/* RIGHT */}

          <motion.div
            className="location-map"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: 0.2,
              ease: "easeOut",
            }}
          >
            <iframe
              src={projectDetail?.map_iframe}
              loading="lazy"
              allowFullScreen
              referrerPolicy="
              no-referrer-when-downgrade
              "
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
